import React from 'react';
import {createStackNavigator} from '@react-navigation/stack';
import LegalScreen from "../screens/settings/LegalScreen";
import TermsOfUse from "../screens/settings/TermsOfUse";
import Imprint from "../screens/settings/Imprint";
import DataSecurity from "../screens/settings/DataSecurity";
import OpenSourceLicense from "../screens/settings/OpenSourceLicense";
import Header from "../components/basic/Header";
import i18n from "i18n-js";
import {Platform} from "react-native";

const legalStack = createStackNavigator()

export default function LegalStack() {

    const verticalAnimation = {
        headerShown: true,
        header: (props) => <Header {...props} />,
        presentation: 'modal',
        //TODO activate Back gesture when android fix is live
        gestureEnabled: Platform.select({ android: false, ios: true }),
        gestureDirection: 'vertical',
        cardStyleInterpolator: ({ current, layouts }) => {
            // console.log("vertival")
            return {
                cardStyle: {
                    transform: [
                        {
                            translateY: current.progress.interpolate({
                                inputRange: [0, 1],
                                outputRange: [layouts.screen.height, 0],
                            }),
                        },
                    ],
                },
            }
        },
    }

    return (
        <legalStack.Navigator initialRouteName='LegalScreen' screenOptions={ verticalAnimation }>
            <legalStack.Screen name='LegalScreen' component={LegalScreen} options={{headerShown: false}}/>
            <legalStack.Screen name='Imprint' component={Imprint} options={{ title: i18n.t('imprint.header') }}/>
            <legalStack.Screen name='TermsOfUse' component={TermsOfUse} options={{ title: i18n.t('tou.header') }}/>
            <legalStack.Screen name='DataSecurity' component={DataSecurity} options={{ title: i18n.t('dpa.header') }}/>
            <legalStack.Screen name='OpenSourceLicense' component={OpenSourceLicense} options={{title: i18n.t('osl.header') }}/>
        </legalStack.Navigator>
    )
}
